// extracted by mini-css-extract-plugin
export var contentContainer = "layout-module--contentContainer--U4H8u";
export var layout = "layout-module--layout--Jg7Rt";